
<template>
  <div>
    <v-card color="white lighten-1" class="ma-3">
      <v-card-text>
        <v-form ref="form" :readonly="readonly">
          <v-autocomplete hide-no-data v-model="vehicle.truck_kind" :items="truck_kinds" label="Tipo"
            prepend-icon="mdi-information" :rules="[rules.required]">
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
          </v-autocomplete>
          <v-text-field v-model="vehicle.plate" label="Placa" prepend-icon="mdi-truck" v-mask="'AAA#X##'" :rules="[rules.required, rules.plate_length]"></v-text-field>
          <v-text-field v-model="vehicle.chassi" label="Chassi" prepend-icon="mdi-garage"></v-text-field>
    
          <v-text-field v-if="plate_count >= 2" v-model="vehicle.cargo_plate_1" label="2ª Placa"
            prepend-icon="mdi-truck" v-mask="'AAA#X##'"
            :rules="[rules.required, rules.plate_length]"></v-text-field>
          <v-text-field v-if="plate_count >= 2" v-model="vehicle.cargo_chassi_1" label="2º Chassi"
            prepend-icon="mdi-garage"></v-text-field>
    
          <v-text-field v-if="plate_count == 3" v-model="vehicle.cargo_plate_2" label="3ª Placa"
            prepend-icon="mdi-truck" v-mask="'AAA#X##'"
            :rules="[rules.required, rules.plate_length]"></v-text-field>
          <v-text-field v-if="plate_count >= 3" v-model="vehicle.cargo_chassi_2" label="3º Chassi"
            prepend-icon="mdi-garage"></v-text-field>
    
          <v-icon large @click="editPlateCount('less')" v-if="plate_count > 1 && !readonly" color="error" class="mr-3">mdi-minus</v-icon>
          <v-icon large @click="editPlateCount('more')" v-if="plate_count < 3 && !readonly" color="light-blue"
            class="ml-3">mdi-plus</v-icon>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  name: 'PlateForm',
  props: {
    vehicle:{
      type: Object,
    },
    this_plate_count:{
      type: Number,
      default: 1
    },
    readonly:{
      type:Boolean,
      default: false,
    }
  },
  data() {
    return {
      truck_kinds: ['Carreta', 'Carreta LS', 'Truck', 'Bitrem', 'Bitruck', 'Rodotrem', 'Vanderleia'],
      plate_count: 1,
      rules: {
        required: v => !!v || 'Campo é necessário',
        plate_length: v => v.length == 7 || 'Faltando dígitos',
      },
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
    setThisPlateCount(){
      this.plate_count = this.this_plate_count
    },
    editPlateCount(increment) {
      if (increment == 'more') {
        this.plate_count += 1;
        if (this.plate_count > 3) {
          this.plate_count = 3;
        } else {
        }
      } else {
        this.plate_count -= 1;
        if (this.plate_count < 2) {
          this.plate_count = 1;
          this.vehicle.cargo_plate_1 = '';
          this.vehicle.cargo_chassi_1 = '';
        } else if (this.plate_count == 2) {
          this.vehicle.cargo_plate_3 = '';
          this.vehicle.cargo_chassi_2 = '';
        }
      }
    },
  },
  mounted(){
    this.setThisPlateCount()
  },
  watch:{
    plate_count(nv){
      this.$emit('changePlateCount', nv)
    },
    this_plate_count(nv){
      this.setThisPlateCount()
    }
  },
}
</script>